<div class="login-body container">
    <div class="row login-grid h-50">
        <div class="col-12 d-flex justify-content-center align-items-center pb-3">
            <img src="imgs/logo.png" class="login-img">
        </div>
        <div class="col-12 d-flex flex-column justify-content-center align-items-center text-center z-1">
            <h1>{{'pages.notFound.ops'|translate}}</h1>
            <h3 class="py-3">{{'pages.notFound.title'|translate}}</h3>
            <p class="pb-3 fs-5">{{'pages.notFound.description1'|translate}}<br />{{'pages.notFound.description2'|translate}}</p>
            <button pButton pRipple type="button" (click)="back()" label="{{'general.buttons.back'|translate|uppercase}}"></button>                              
        </div>
    </div>
</div>
